import Quill from 'quill';
// import BlotFormatter from "quill-blot-formatter";
import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from 'react';
import 'quill/dist/quill.snow.css';
import './style.css';

const Editor = ({value: alsoDefaultValue, onChange, height}) => {
  const [quillValue, setQuillValue] = useState('');
  const $editorContRef = useRef();
  const handleContentsChange = () => {
    onChange(getHTMLValue());
  };

  const getHTMLValue = () => {
    if (
      $editorContRef.current.querySelector('.ql-editor') !== null ||
      undefined
    ) {
      return $editorContRef.current.querySelector('.ql-editor').innerHTML;
    }
  };

  const insertInitialValue = (quill) => {
    quill.clipboard.dangerouslyPasteHTML(0, alsoDefaultValue);
    quill.blur();
  };

  useEffect(() => {
    var Font = Quill.import('formats/font');

    Font.whitelist = ['Sans Serif', 'Arial', 'Helvetica', 'Roboto'];
    Quill.register(Font, true);

    var quill = new Quill('#editor-container', {
      modules: {
        toolbar: '#toolbar-container'
      },
      placeholder: 'Stat editing...',
      theme: 'snow'
    });
    if (quill) {
      setQuillValue(quill);
      quill.on('text-change', handleContentsChange);
      insertInitialValue(quill);

      return () => {
        quill.off('text-change', handleContentsChange);
        quill = null;
      };
    }
  }, [alsoDefaultValue]);

  return (
    <div
      className="main-editor"
      style={{minHeight: height ?? '150px'}}
      ref={$editorContRef}
    >
      <div id="toolbar-container">
        <select className="ql-size">
          <option value="small">Small</option>

          <option selected>Normal</option>
          <option value="large">Large</option>
          <option value="huge">Huge</option>
        </select>
        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>
        <button className="ql-strike"></button>
        <button className="ql-blockquote"></button>
        <span className="ql-formats">
          <button className="ql-list" value="ordered" type="button"></button>
          <button className="ql-list" value="bullet" type="button"></button>
          <button className="ql-indent" value="-1" type="button"></button>
          <button className="ql-indent" value="+1" type="button"></button>
        </span>
        <button className="ql-link" type="button"></button>
      </div>
      <div id="editor-container"></div>
    </div>
  );
};
export default Editor;
